import { TDropItem } from 'src/types';

export const academicDisciplineOptions: TDropItem[] = [
  { value: 'academicDisciplineEnglish', label: 'English' },
  { value: 'academicDisciplineMatch', label: 'Math' },
  { value: 'academicDisciplineHistory', label: 'History' },
  { value: 'academicDisciplineScience', label: 'Science' },
  { value: 'academicDisciplineForeignLanguage', label: 'Foreign Language' },
  { value: 'academicDisciplineOther', label: 'Other:' },
];
